import moment from "moment";
import {
  CITIES,
  FIELDS,
  REVIEWS_TAGS,
} from "../../../components/utils/constants";
import { Link } from "react-router-dom";
import { useContext, useEffect } from "react";
import useDistrictNameById from "../../../components/helpers/useDistrictNameByCityAndId";
import { UserContext } from "../../../App";
import Comments from "../../../components/InternalComments/Comments";
import { useTranslation } from "react-i18next";

const SingleTabDetails = ({
  worker,
  workerStatistics,
  handleClickChangePassword,
  openWorkerLocation,
  setIsActionLoading,
  vendor=null
}) => {

  const {fields} = useContext(UserContext);
  const { t, i18n } = useTranslation();

  return (
    <>
      <div className="border-[1px] border-grey-200 rounded-[16px] px-[20px] py-[30px] my-[24px] bg-white">
        <div className="flex flex-wrap lg:flex-nowrap lg:h-[146px]">
          <div className="w-full lg:w-[calc(100%-361px)] border-e-0 lg:border-e-[1px] border-grey-200">
            <div className="text-grey-900 text-[24px] font-[600] leading-[36px]">
              {worker?.name} -{" "}
              <span dir="ltr">{`[ ${worker?.username} ]`}</span>
              <div className="inline-block ms-[12px]">
                {worker?.suspendedTo &&
                Date.parse(new Date(worker?.suspendedTo)) >=
                  Date.parse(new Date()) ? (
                  <div className="inline-block bg-grey-100 h-[22px] px-[8px] leading-[22px] rounded-[20px] me-[8px] text-grey-600 text-[12px] font-[500] opacity-50">
                    <span className="bg-grey-400 w-[8px] h-[8px] rounded-full me-[4px] inline-block"></span>
                    {t('workers.suspended')}
                  </div>
                ) : (
                  <div className="inline-block bg-grey-50 h-[22px] px-[8px] leading-[22px] rounded-[20px] me-[8px] text-darkBlue text-[12px] font-[500]">
                    <span className="bg-darkBlue w-[8px] h-[8px] rounded-full me-[4px] inline-block"></span>
                    {t('workers.active')}
                  </div>
                )}

                {worker?.featuredSubscriptionValidTo &&
                Date.parse(new Date(worker?.featuredSubscriptionValidTo)) >=
                  Date.parse(new Date()) ? (
                  <div className="inline-block bg-orange/10 h-[22px] px-[8px] leading-[22px] rounded-[20px] me-[8px] text-orange text-[12px] font-[500]">
                    <span className="bg-orange w-[8px] h-[8px] rounded-full me-[4px] inline-block"></span>
                    {t('workers.featured')}
                  </div>
                ) : (
                  <div className="inline-block bg-grey-50 h-[22px] px-[8px] leading-[22px] rounded-[20px] me-[8px] text-grey-600 text-[12px] font-[500]">
                    <span className="bg-grey-600 w-[8px] h-[8px] rounded-full me-[4px] inline-block"></span>
                    {t('workers.normal')}
                  </div>
                )}

                {worker?.status === 'available' ? (
                  <div className="inline-block bg-blue/10 h-[22px] px-[8px] leading-[22px] rounded-[20px] me-[8px] text-blue text-[12px] font-[500]">
                    <span className="bg-blue w-[8px] h-[8px] rounded-full me-[4px] inline-block"></span>
                    {t('workers.available')}
                  </div>
                ) : (
                  <div className="inline-block bg-danger/10 h-[22px] px-[8px] leading-[22px] rounded-[20px] me-[8px] text-danger text-[12px] font-[500]">
                    <span className="bg-danger w-[8px] h-[8px] rounded-full me-[4px] inline-block"></span>
                    {t('workers.unavailable')}
                  </div>
                )}
              </div>
            </div>
            <div className="flex flex-wrap lg:flex-nowrap mt-[25px] pt-[20px] border-t-[1px] border-grey-200">
              <div className="w-[50%] lg:w-[200px] h-[60px] relative">
                <strong className="text-[24px] text-grey-900 font-[600] leading-[36px]">
                  {worker?.fields?.map(wf=>fields?.find(f=>f?.field?.code === wf)?.field?.name?.[i18n.language === 'ar' ? 'ar' : 'en'] || fields?.find(f=>f?.field?.code === wf)?.field?.name?.ar).join(', ')}
                  {worker?.multiFieldsSubscriptionValidTo ? <small className="block font-normal text-[12px] mt-[3px] mb-[5px] leading-[1]">{t('workerDetails.untilDate')} {moment(worker?.multiFieldsSubscriptionValidTo).format("DD/MM/YYYY")}</small> : ''}
                </strong>
                <p className="text-[14px] text-grey-600 font-[500]">
                  <img
                    src="/assets/images/worker-field.svg"
                    alt=""
                    className="inline-block align-sub me-[3px]"
                  />
                  {t('workerDetails.specialization')}
                </p>
                <span className="absolute block w-[1px] h-[40px] bg-grey-300 end-0 top-[10px]"></span>
              </div>
              <div className="w-[50%] lg:w-[260px] h-[60px] ps-[15px] lg:ps-[60px] relative">
                <strong className="text-[24px] text-grey-900 font-[600] leading-[36px]">
                  {CITIES[worker?.city]?.[i18n.language === 'ar' ? 'ar' : 'en'] || CITIES[worker?.city]?.ar}
                </strong>
                <p className="text-[14px] text-grey-600 font-[500]">
                  <img
                    src="/assets/images/workers-cities-icon.svg"
                    alt=""
                    className="inline-block align-sub me-[3px]"
                  />
                  {t('workerDetails.city')}
                </p>
                <span className="absolute w-[1px] h-[40px] bg-grey-300 end-0 top-[10px] hidden lg:block"></span>
              </div>
              <div className="w-[50%] lg:w-[200px] lg:h-[60px] ps-0 lg:ps-[60px] relative py-[15px] lg:py-0">
                <strong className="text-[24px] text-grey-900 font-[600] leading-[36px]">
                  <span className="text-nowrap" dir="ltr">
                    +996 {worker?.username?.replace("966", "")}
                  </span>
                </strong>
                <p className="text-[14px] text-grey-600 font-[500]">
                  <img
                    src="/assets/images/worker-phone.svg"
                    alt=""
                    className="inline-block align-sub me-[3px]"
                  />
                  {t('workerDetails.mobileNumber')}
                </p>
              </div>
            </div>
          </div>
          <div className="w-[341px] flex flex-wrap justify-end items-center gap-[12px] translate-y-[-12px] content-center pt-[15px]">
            <div
              className="w-full lg:w-[324px] h-[48px] leading-[48px] bg-blue text-white rounded-[8px] text-center font-[600] text-[18px] cursor-pointer transition-transform hover:scale-105"
              onClick={() => handleClickChangePassword()}
            >
              <img
                src="/assets/images/worker-password.svg"
                alt=""
                className="inline-block me-[5px]"
              />
              {t('workerDetails.changePassword')}
            </div>
            <Link
              to={`/${i18n?.language || 'ar'}/workers/edit/${worker?.username}`}
              className="w-full lg:w-[324px] h-[48px] leading-[48px] bg-darkBlue text-white rounded-[8px] text-center font-[600] text-[18px] transition-transform hover:scale-105"
            >
              <img
                src="/assets/images/worker-edit.svg"
                alt=""
                className="inline-block me-[5px]"
              />
              {t('workerDetails.editWorkerData')}
            </Link>
          </div>
        </div>
      </div>

      <div className="flex flex-wrap lg:flex-nowrap gap-[32px] pb-[24px]">
        <div className="w-full lg:w-[calc(100%-550px)]">
          <div className="h-[43px] bg-grey-200 text-center rounded-t-[8px] leading-[43px] text-grey-900 text-[18px] font-[700]">
            {t('workerDetails.details')}
          </div>
          <div className="border-[1px] border-t-0 border-grey-200 rounded-b-[8px] overflow-hidden">

            <div className="flex flex-nowrap bg-white px-[16px]">
              <div className="w-[75%] h-[37px] leading-[37px] text-blue text-[14px] font-[400]">
                {t('workerDetails.idNumber')}
              </div>
              <div className="w-[25%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500] text-end">
                {worker?.governmentId || "-"}
              </div>
            </div>

            <div className="flex flex-nowrap bg-grey-50 px-[16px]">
              <div className="w-[75%] h-[37px] leading-[37px] text-blue text-[14px] font-[400]">
                {t('workerDetails.district')}
              </div>
              <div className="w-[25%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500] text-end">
                {useDistrictNameById(worker?.city,worker?.district) || "-"}
              </div>
            </div>

            

            <div className="flex flex-nowrap bg-white px-[16px]">
              <div className="w-[75%] h-[37px] leading-[37px] text-blue text-[14px] font-[400]">
                {t('workerDetails.suspended')}
              </div>
              <div className="w-[25%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500] text-end">
                {!worker?.suspendedTo ||
                Date.parse(new Date(worker?.suspendedTo)) <
                  Date.parse(new Date())
                  ? t('workerDetails.no')
                  : `${t('workerDetails.suspendedUntil')} ${moment(worker?.suspendedTo).format("DD/MM/YYYY")}`}
              </div>
            </div>

            <div className="flex flex-nowrap bg-grey-50 px-[16px]">
              <div className="w-[75%] h-[37px] leading-[37px] text-blue text-[14px] font-[400]">
                {t('workerDetails.featured')}
              </div>
              <div className="w-[25%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500] text-end">
                {!worker?.featuredSubscriptionValidTo ||
                Date.parse(new Date(worker?.featuredSubscriptionValidTo)) <
                  Date.parse(new Date())
                  ? t('workerDetails.no')
                  : t('workerDetails.yes')}
              </div>
            </div>

            <div className="flex flex-nowrap bg-white px-[16px]">
              <div className="w-[75%] h-[37px] leading-[37px] text-blue text-[14px] font-[400]">
                {t('workerDetails.elite')}
              </div>
              <div className="w-[25%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500] text-end">
                {!worker?.elite ? t('workerDetails.no') : t('workerDetails.yes')}
              </div>
            </div>

            <div className="flex flex-nowrap bg-grey-50 px-[16px]">
              <div className="w-[75%] h-[37px] leading-[37px] text-blue text-[14px] font-[400]">
                {t('workerDetails.averageRating')}
              </div>
              <div className="w-[25%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500] text-end">
                {(
                  worker?.rateSum /
                    (worker?.numberOfReviews === 0
                      ? 1
                      : worker?.numberOfReviews) || 0
                )?.toFixed(1)}
              </div>
            </div>

            <div className="flex flex-nowrap bg-white px-[16px]">
              <div className="w-[75%] h-[37px] leading-[37px] text-blue text-[14px] font-[400]">
                {t('workerDetails.workerLevel')}
              </div>
              <div className="w-[25%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500] text-end">
                {worker?.classificationDetails?.title?.[i18n.language === 'ar' ? 'ar' : 'en'] || worker?.classificationDetails?.title?.ar || "-"}
              </div>
            </div>

            {worker?.residenceDocumentUrl  ? <div className="flex flex-nowrap bg-white px-[16px]">
              <div className="w-[75%] h-[37px] leading-[37px] text-blue text-[14px] font-[400]">
                {t('workerDetails.residenceDocument')}
              </div>
              <div className="w-[25%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500] text-end">
                <Link to={worker?.residenceDocumentUrl } target="_blank" className="text-darkBlue underline">{t('workerDetails.viewDocument')}</Link>
              </div>
            </div> : ''}

            

            <div className="flex flex-nowrap bg-grey-50 px-[16px]">
              <div className="w-[75%] h-[37px] leading-[37px] text-blue text-[14px] font-[400]">
                {t('workerDetails.createdAt')}
              </div>
              <div className="w-[25%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500] text-end">
                {moment(worker?.createdAt).format("DD/MM/YYYY")}
              </div>
            </div>

            <div className="flex flex-nowrap bg-white px-[16px]">
              <div className="w-[75%] h-[37px] leading-[37px] text-blue text-[14px] font-[400]">
                {t('workerDetails.updatedAt')}
              </div>
              <div className="w-[25%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500] text-end">
                {moment(worker?.updatedAt).format("DD/MM/YYYY")}
              </div>
            </div>

            <div className="flex flex-nowrap bg-grey-50 px-[16px]">
              <div className="w-[75%] ltr:w-[60%] h-[37px] leading-[37px] text-blue text-[14px] font-[400]">
                {t('workerDetails.workerLocation')}
              </div>
              <div className="w-[25%] ltr:w-[40%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500] text-end whitespace-nowrap">
                {worker?.location ? (
                  <>
                    <img
                      src="/assets/images/request-location.svg"
                      alt=""
                      className="inline-block align-middle w-[24px] h-[24px] ms-[4px]"
                    />{" "}
                    <span
                      className="cursor-pointer font-[500] text-[14px] text-darkBlue inline-block align-middle ltr:text-[14px]"
                      onClick={() =>
                        openWorkerLocation(
                          worker?.location?.latitude,
                          worker?.location?.longitude,
                        )
                      }
                    >
                      {t('workerDetails.viewWorkerLocation')}
                    </span>
                  </>
                ) : (
                  t('requests.unspecified')
                )}
              </div>
            </div>

            <div className="flex flex-nowrap bg-white px-[16px]">
              <div className="w-[75%] h-[37px] leading-[37px] text-blue text-[14px] font-[400]">
                {t('workerDetails.autoApplySubscription')}
              </div>
              <div className="w-[25%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500] text-end">
                {!worker?.autoApplyToRequestsSubscriptionValidTo ||
                Date.parse(
                  new Date(worker?.autoApplyToRequestsSubscriptionValidTo),
                ) < Date.parse(new Date())
                  ? t('workerDetails.no')
                  : t('workerDetails.yes')}
              </div>
            </div>

            <div className="flex flex-nowrap bg-grey-50 px-[16px]">
              <div className="w-[75%] h-[37px] leading-[37px] text-blue text-[14px] font-[400]">
                {t('workerDetails.multiFieldSubscription')}
              </div>
              <div className="w-[25%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500] text-end">
                {!worker?.multiFieldsSubscriptionValidTo ||
                Date.parse(new Date(worker?.multiFieldsSubscriptionValidTo)) <
                  Date.parse(new Date())
                  ? t('workerDetails.no')
                  : t('workerDetails.yes')}
              </div>
            </div>

            <div className="flex flex-nowrap bg-white px-[16px]">
              <div className="w-[75%] h-[37px] leading-[37px] text-blue text-[14px] font-[400]">
                {t('workerDetails.totalWorkerWage')}
              </div>
              <div className="w-[25%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500] text-end">
                {workerStatistics?.totalWorkerWage
                  ? <span>{workerStatistics?.totalWorkerWage?.toFixed(2) || '0.00'}
                    <img src="/assets/images/pack-sar.svg" alt="" className="inline-block align-baseline ms-[3px] w-[11px]" /></span>
                  : "0"}
              </div>
            </div>

            <div className="flex flex-nowrap bg-grey-50 px-[16px]">
              <div className="w-[75%] h-[37px] leading-[37px] text-blue text-[14px] font-[400]">
                {t('workerDetails.totalCompletedRequests')}
              </div>
              <div className="w-[25%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500] text-end">
                {workerStatistics?.requestCounts?.totalDoneRequests}
              </div>
            </div>

            <div className="flex flex-nowrap bg-white px-[16px]">
              <div className="w-[75%] h-[37px] leading-[37px] text-blue text-[14px] font-[400]">
                {t('workerDetails.totalCanceledRequests')}
              </div>
              <div className="w-[25%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500] text-end">
                {workerStatistics?.requestCounts?.canceled}
              </div>
            </div>

            <div className="flex flex-nowrap bg-white px-[16px]">
              <div className="w-[75%] h-[37px] leading-[37px] text-blue text-[14px] font-[400]">
                {t('workerDetails.totalPostponedRequests')}
              </div>
              <div className="w-[25%] h-[37px] leading-[37px] text-grey-900 text-[14px] font-[500] text-end">
                {workerStatistics?.requestCounts?.postponed}
              </div>
            </div>
          </div>
        </div>
        <div className="w-full lg:w-[550px]">
          <div className="h-[43px] bg-grey-200 text-center rounded-t-[8px] leading-[43px] text-grey-900 text-[18px] font-[700]">
            {t('workerDetails.ratingFactors')}
          </div>
          <div className="border-[1px] border-t-0 border-grey-200 rounded-b-[8px] bg-white p-[8px]">
            <p className="text-black font-[500] text-[16px] leading-[24px]">
              {t('workerDetails.positiveRatings')}
            </p>
            <div className="mt-[8px] mb-[16px] flex flex-nowrap p-[8px] gap-[4px] justify-between">
              {Object.keys(REVIEWS_TAGS)?.map((tag, index) => {
                if (index < 6) {
                  return (
                    <div key={"goodRates-" + index} className="text-center">
                      <img
                        src={`/assets/images/worker-rates/${tag}.svg`}
                        alt=""
                        className="block w-[40px] h-[40px] mx-auto"
                      />
                      <span
                        className={`block font-[600] text-[16px] leading-[24px] ${workerStatistics?.rateFactors[tag] > 0 ? "text-blue" : "text-grey-400"}`}
                      >
                        {workerStatistics?.rateFactors[tag]}
                      </span>
                      <span className="block text-grey-600 text-[14px] ltr:text-[12px] font-[500] text-center lg:text-nowrap">
                        {REVIEWS_TAGS[tag]?.[i18n.language === 'ar' ? 'ar' : 'en'] || REVIEWS_TAGS[tag]?.ar}
                      </span>
                    </div>
                  );
                }
              })}
            </div>
            <p className="text-black font-[500] text-[16px] leading-[24px]">
              {t('workerDetails.negativeRatings')}
            </p>
            <div className="mt-[8px] mb-[16px] flex flex-nowrap p-[8px] gap-[4px] justify-between">
              {Object.keys(REVIEWS_TAGS)?.map((tag, index) => {
                if (index > 5) {
                  return (
                    <div key={"goodRates-" + index} className="text-center">
                      <img
                        src={`/assets/images/worker-rates/${tag}.svg`}
                        alt=""
                        className="block w-[40px] h-[40px] mx-auto"
                      />
                      <span
                        className={`block font-[600] text-[16px] leading-[24px] ${workerStatistics?.rateFactors[tag] > 0 ? "text-danger" : "text-grey-400"}`}
                      >
                        {workerStatistics?.rateFactors[tag]}
                      </span>
                      <span className="block text-grey-600 text-[14px] ltr:text-[10px] font-[500] text-center lg:text-nowrap">
                        {REVIEWS_TAGS[tag]?.[i18n.language === 'ar' ? 'ar' : 'en'] || REVIEWS_TAGS[tag]?.ar}
                      </span>
                    </div>
                  );
                }
              })}
            </div>
          </div>
          <Comments resourceLable={t('workerDetails.resourceLabel')} resourceType={'workers'} resourceId={worker?._id} vendor={vendor} />
        </div>
      </div>
    </>
  );
};

export default SingleTabDetails;
